"use strict";
//menu
window.addEventListener("hashchange", ()=>{
    if (window.location.hash === "#menu") document.body.classList.add("page__body--with-menu");
    else document.body.classList.remove("page__body--with-menu");
});
//animation
const phoneScreen = document.querySelector(".phone__screen");
function showPhoneScreen() {
    const screenTop = phoneScreen.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    if (screenTop + 80 < windowHeight) {
        phoneScreen.classList.add("phone__screen--show");
        window.removeEventListener("scroll", showPhoneScreen);
    }
}
window.addEventListener("load", showPhoneScreen);
window.addEventListener("scroll", showPhoneScreen);
// SPOLLERS
const spollersArray = document.querySelectorAll("[data-spollers]");
if (spollersArray.length > 0) {
    // Получение обычных слойлеров
    const spollersRegular = Array.from(spollersArray).filter(function(item, index, self) {
        return !item.dataset.spollers.split(",")[0];
    });
    // Инициализация обычных слойлеров
    if (spollersRegular.length > 0) initSpollers(spollersRegular);
    // Получение слойлеров с медиа запросами
    const spollersMedia = Array.from(spollersArray).filter(function(item, index, self) {
        return item.dataset.spollers.split(",")[0];
    });
    // Инициализация слойлеров с медиа запросами
    if (spollersMedia.length > 0) {
        const breakpointsArray = [];
        spollersMedia.forEach((item)=>{
            const params = item.dataset.spollers;
            const breakpoint = {};
            const paramsArray = params.split(",");
            breakpoint.value = paramsArray[0];
            breakpoint.type = paramsArray[1] ? paramsArray[1].trim() : "max";
            breakpoint.item = item;
            breakpointsArray.push(breakpoint);
        });
        // Получаем уникальные брейкпоинты
        let mediaQueries = breakpointsArray.map(function(item) {
            return "(" + item.type + "-width: " + item.value + "px)," + item.value + "," + item.type;
        });
        mediaQueries = mediaQueries.filter(function(item, index, self) {
            return self.indexOf(item) === index;
        });
        // Работаем с каждым брейкпоинтом
        mediaQueries.forEach((breakpoint)=>{
            const paramsArray = breakpoint.split(",");
            const mediaBreakpoint = paramsArray[1];
            const mediaType = paramsArray[2];
            const matchMedia = window.matchMedia(paramsArray[0]);
            // Объекты с нужными условиями
            const spollersArray = breakpointsArray.filter(function(item) {
                if (item.value === mediaBreakpoint && item.type === mediaType) return true;
            });
            // Событие
            matchMedia.addListener(function() {
                initSpollers(spollersArray, matchMedia);
            });
            initSpollers(spollersArray, matchMedia);
        });
    }
    // Инициализация
    function initSpollers(spollersArray, matchMedia = false) {
        spollersArray.forEach((spollersBlock)=>{
            spollersBlock = matchMedia ? spollersBlock.item : spollersBlock;
            if (matchMedia.matches || !matchMedia) {
                spollersBlock.classList.add("spoller-block--init");
                initSpollerBody(spollersBlock);
                spollersBlock.addEventListener("click", setSpollerAction);
            } else {
                spollersBlock.classList.remove("spoller-block--init");
                initSpollerBody(spollersBlock, false);
                spollersBlock.removeEventListener("click", setSpollerAction);
            }
        });
    }
    // Работа с контентом
    function initSpollerBody(spollersBlock, hideSpollerBody = true) {
        const spollerTitles = spollersBlock.querySelectorAll("[data-spoller]");
        if (spollerTitles.length > 0) spollerTitles.forEach((spollerTitle)=>{
            if (hideSpollerBody) {
                spollerTitle.removeAttribute("tabindex");
                if (!spollerTitle.classList.contains("spoller-block__title--active")) spollerTitle.nextElementSibling.hidden = true;
            } else {
                spollerTitle.setAttribute("tabindex", "-1");
                spollerTitle.nextElementSibling.hidden = false;
            }
        });
    }
    function setSpollerAction(e) {
        const el = e.target;
        if (el.hasAttribute("data-spoller") || el.closest("[data-spoller]")) {
            const spollerTitle = el.hasAttribute("data-spoller") ? el : el.closest("[data-spoller]");
            const spollersBlock = spollerTitle.closest("[data-spollers]");
            const oneSpoller = spollersBlock.hasAttribute("data-one-spoller") ? true : false;
            if (!spollersBlock.querySelectorAll("._slide").length) {
                if (oneSpoller && !spollerTitle.classList.contains("spoller-block__title--active")) hideSpollersBody(spollersBlock);
                spollerTitle.classList.toggle("spoller-block__title--active");
                _slideToggle(spollerTitle.nextElementSibling, 500);
            }
            e.preventDefault();
        }
    }
    function hideSpollersBody(spollersBlock) {
        const spollerActiveTitle = spollersBlock.querySelector("[data-spoller].spoller-block__title--active");
        if (spollerActiveTitle) {
            spollerActiveTitle.classList.remove("spoller-block__title--active");
            _slideUp(spollerActiveTitle.nextElementSibling, 500);
        }
    }
}
//========================================================================================================================================================
//SlideToggle
let _slideUp = (target, duration = 500)=>{
    if (!target.classList.contains("_slide")) {
        target.classList.add("_slide");
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + "ms";
        target.style.height = target.offsetHeight + "px";
        target.offsetHeight;
        target.style.overflow = "hidden";
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(()=>{
            target.hidden = true;
            target.style.removeProperty("height");
            target.style.removeProperty("padding-top");
            target.style.removeProperty("padding-bottom");
            target.style.removeProperty("margin-top");
            target.style.removeProperty("margin-bottom");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
            target.classList.remove("_slide");
        }, duration);
    }
};
let _slideDown = (target, duration = 500)=>{
    if (!target.classList.contains("_slide")) {
        target.classList.add("_slide");
        if (target.hidden) target.hidden = false;
        let height = target.offsetHeight;
        target.style.overflow = "hidden";
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + "ms";
        target.style.height = height + "px";
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        window.setTimeout(()=>{
            target.style.removeProperty("height");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
            target.classList.remove("_slide");
        }, duration);
    }
};
let _slideToggle = (target, duration = 500)=>{
    if (target.hidden) return _slideDown(target, duration);
    else return _slideUp(target, duration);
} //========================================================================================================================================================
 /*
Для родителя слойлеров пишем атрибут data-spollers
Для заголовков слойлеров пишем атрибут data-spoller
Если нужно включать\выключать работу спойлеров на разных размерах экранов
пишем параметры ширины и типа брейкпоинта.
Например:
data-spollers="992,max" - спойлеры будут работать только на экранах меньше или равно 992px
data-spollers="768,min" - спойлеры будут работать только на экранах больше или равно 768px

Если нужно что бы в блоке открывался болько один слойлер добавляем атрибут data-one-spoller
*/ ;

//# sourceMappingURL=index.a017b59c.js.map
